<script>
import ClientesService from '@/services/clientes.service';
import { PaginacionDefault, Rol, ContratoCreateInit } from '@/constants/global';
import Utils from '@/functions/utils';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';


export default {

  data() {
    return {
      disabledDates: false,
      isBlockedButton: false,
      loading: false,
      roles: Rol,
      asesores: [],
      paquetes: [],
      docs: [],
      tipoPlanes: [],
      asesorCurrent: {},
      usuario: authService.getUser(),
      errores: {},
      erroresDirecciones: [],
      empresa: {
        ruc: null,
        razonSocial: null
      },
      direcciones: [],
      contratoForm: {...ContratoCreateInit}
    }
  },
  mounted() {
    this.getUsuarios();
    this.getPaquetes();
    this.getDocumentos();
    this.getTipoPlanes();
  },
  methods: {
    async getPaquetes() {
      this.paquetes = await ClientesService.getPaquetes();
    },
    async getDocumentos() {
      this.docs = await ClientesService.getDocumentos();
    },
    async getTipoPlanes() {
      this.tipoPlanes = await ClientesService.getTipoPlanes();
    },
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
      this.asesorCurrent = this.asesores.find(fnd => fnd.value == this.usuario.idUsuario);
    },
    btnAgregarDireccion_click() {
      this.isBlockedButton = this.direcciones.length >= 9;
      if (!this.isBlockedButton) {
        this.direcciones.push({ descripcion: '', estado: 0 });
      }
    },
    ckbPromocion_click() {
      this.disabledDates = !this.disabledDates;
      if (this.disabledDates) {
        this.contratoForm.inicioPromo = null;
        this.contratoForm.finPromo = null;
      }
    },
    inpFileUpload_handle(event) {
      this.contratoForm.file = event.target.files[0];
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idasesor = Rol.ADMINISTRADOR == this.usuario.rol
        && (this.contratoForm.asesor == null || this.contratoForm.asesor == -1);
      this.errores.ruc = this.empresa.ruc == null || this.empresa.ruc.trim() == '';
      this.errores.razonSocial = this.empresa.razonSocial == null || this.empresa.razonSocial.trim() == '';
      this.errores.direccion = this.contratoForm.direccion == null || this.contratoForm.direccion.trim() == '';
      this.erroresDirecciones = this.direcciones.map(map => { return map.descripcion == null || map.descripcion.trim() == '' });
      this.errores.paquete = this.contratoForm.paquete == null || this.contratoForm.paquete == -1;
      this.errores.sucursales = this.contratoForm.sucursales == null || this.contratoForm.sucursales <= 0;
      this.errores.usuarios = this.contratoForm.usuarios == null
        || this.contratoForm.usuarios.trim() == ''
        || (!isNaN(this.contratoForm.usuarios) && this.contratoForm.usuarios <= 0);
      this.errores.numComprobantes = this.contratoForm.numComprobantes == null
        || this.contratoForm.numComprobantes.trim() == ''
        || (!isNaN(this.contratoForm.numComprobantes) && this.contratoForm.numComprobantes <= 0);
      this.errores.doc = this.contratoForm.doc == null || this.contratoForm.doc == -1;
      this.errores.plan = this.contratoForm.plan == null || this.contratoForm.plan == -1;
      this.errores.costoPlan = this.contratoForm.costoPlan == null || this.contratoForm.costoPlan < 0;
      this.errores.costoMensual = this.contratoForm.costoMensual == null || this.contratoForm.costoMensual < 0;
      this.errores.costoInscripcion = this.contratoForm.costoInscripcion == null || this.contratoForm.costoInscripcion < 0;
      this.errores.inicioPromo = !this.disabledDates && (this.contratoForm.inicioPromo == null || this.contratoForm.inicioPromo.trim() == '');
      this.errores.finPromo = !this.disabledDates && (this.contratoForm.finPromo == null || this.contratoForm.finPromo.trim() == '');
      this.errores.inicioFacturacion = this.contratoForm.inicioFacturacion == null || this.contratoForm.inicioFacturacion.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      let existErrorDireccion = this.erroresDirecciones.some(key => key);
      if (existError) return;
      if (existErrorDireccion) return;

      this.loading = true;
      spinnerService.show();

      try {
        let archivoName = '';
        if (this.contratoForm.file) {
          const formData = new FormData();
          formData.append('file', this.contratoForm.file);
          let res = await ClientesService.uploadPago(formData);
          archivoName = res.nombre;
        }

        //Lista de direcciones
        let listadirecciones = this.direcciones.map(map => { return { descripcion: map.descripcion }});
        listadirecciones.unshift({ descripcion: this.contratoForm.direccion });
        //Construyento el Objeto a guardar
        let obj = {
          IdAsesor: this.contratoForm.asesor == -1 ? this.asesorCurrent.value : this.contratoForm.asesor,
          Ruc: this.empresa.ruc,
          RazonSocial: this.empresa.razonSocial,
          IdPaquete: this.contratoForm.paquete,
          NumSucursales: this.contratoForm.sucursales,
          NumComprobantes: isNaN(this.contratoForm.numComprobantes) ? null : this.contratoForm.numComprobantes,
          NumUsuarios: isNaN(this.contratoForm.usuarios) ? null : this.contratoForm.usuarios,
          IdDocInterno: this.contratoForm.doc,
          SoloDocsInternos: this.contratoForm.docInternos ? 1 : 0,
          IdTipoPlan: this.contratoForm.plan,
          CostoPlan: this.contratoForm.costoPlan,
          CostoMensual: this.contratoForm.costoMensual,
          CostoInscripcion: this.contratoForm.costoInscripcion,
          FechaInicioPromo: this.contratoForm.inicioPromo,
          FechaFinPromo: this.contratoForm.finPromo,
          FechaFacturacion: this.contratoForm.inicioFacturacion,
          Observaciones: this.contratoForm.observaciones,
          NombrePago: archivoName,
          FechaContrato: new Date(),
          Direcciones: listadirecciones
        }

        await ClientesService.createContrato(obj);
        Utils.mostrarMensajeExito('El contrato se ha guardado exitosamente');
        this.loading = false;
        this.contratoForm = {...ContratoCreateInit};
        this.empresa = {
          ruc: null,
          razonSocial: null
        };
        this.direcciones = [];
        this.errores = {};
        this.erroresDirecciones = [];
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'El RUC ingresado ya existe')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>

  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>Nuevo Contrato</h1>
            <p>REGISTRE LOS DATOS DEL NUEVO CONTRATO</p>
          </div>
          <div class="card-body p-5">
            <form id="regis" action="/saveCont" method="POST" enctype="multipart/form-data">
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="asesor" class="form-control-lg">Asesor de Ventas</label>
                  </div>
                  <div class="col-sm-7">
                    <select v-if="usuario.rol == roles.ADMINISTRADOR" name="cnt_ase" id="cnt_ase"
                      v-model="contratoForm.asesor" class="req form-select form-control-lg"
                      v-bind:class="{ 'invalid': errores.idasesor }">
                      <option value="-1">Seleccione un asesor</option>
                      <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                        {{ asesor.label }}
                      </option>
                    </select>
                    <template v-else>
                      <input type="text" class="form-control form-control-lg" :value="asesorCurrent.label" disabled
                        v-bind:class="{ 'invalid': errores.idasesor }">
                      <input type="hidden" name="cnt_ase" id="cnt_ase" class="form-control form-control-lg"
                        :value="asesorCurrent.value">
                    </template>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del cliente</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="con_ruc" class="form-control-lg">RUC</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="empresa.ruc"
                      v-bind:class="{ 'invalid': errores.ruc }" name="cnt_ruc" id="cnt_ruc" maxlength="11">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_razsoc" class="form-control-lg">Razón Social</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="empresa.razonSocial"
                      v-bind:class="{ 'invalid': errores.razonSocial }" name="cnt_razsoc" id="cnt_razsoc" maxlength="255">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Direcciones SUNAT</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="con_dir1" class="form-control-lg">Dirección 1</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="contratoForm.direccion"
                      v-bind:class="{ 'invalid': errores.direccion }" name="cnt_dir1" id="cnt_dir1" maxlength="255">
                  </div>
                </div>
                <template v-for="direccion, index in direcciones" :key="index">
                  <div class="row">
                    <div class="col">
                      <label :for="'con_dir' + (index + 2)" class="form-control-lg">Dirección {{ index + 2 }}</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg"
                        v-bind:class="{ 'invalid': erroresDirecciones[index] }" v-model="direccion.descripcion"
                        :name="'cnt_dir' + (index + 2)" :id="'cnt_dir' + (index + 2)" maxlength='255'>
                    </div>
                  </div>
                </template>
                <div class="row">
                  <div class="col"></div>
                  <div class="col-sm-7">
                    <button type="button" id="add-d" class="btn form-control btn-lg"
                      v-bind:class="{ 'btn-success': !isBlockedButton, 'btn-secondary': isBlockedButton }"
                      @click="btnAgregarDireccion_click">Agregar dirección</button>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del paquete contratado</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="paquete" class="form-control-lg">Paquete</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cnt_pkt" id="cnt_pkt" class="req form-select form-control-lg"
                      v-model="contratoForm.paquete" v-bind:class="{ 'invalid': errores.paquete }">
                      <option value="-1">Seleccione un paquete</option>
                      <option v-for="paquete in paquetes" :key="paquete.value" :value="paquete.value">
                        {{ paquete.label }}
                      </option>

                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_suc" class="form-control-lg">Sucursales</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="number" class="req form-control form-control-lg" name="cnt_suc" id="cnt_suc"
                      maxlength="50" v-model="contratoForm.sucursales" v-bind:class="{ 'invalid': errores.sucursales }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_can" class="form-control-lg">Cantidad de usuarios</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cnt_cnt_usu" id="cnt_cnt_usu"
                      maxlength="20" v-model="contratoForm.usuarios" v-bind:class="{ 'invalid': errores.usuarios }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_com" class="form-control-lg">Cantidad de comprobantes</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cnt_cnt_com" id="cnt_cnt_com"
                      maxlength="20" v-model="contratoForm.numComprobantes"
                      v-bind:class="{ 'invalid': errores.numComprobantes }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="docs" class="form-control-lg">Documentos internos</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cnt_doc" id="cnt_doc" class="req form-control-lg form-select" v-model="contratoForm.doc"
                      v-bind:class="{ 'invalid': errores.doc }">
                      <option value="-1">Seleccione un documento</option>
                      <option v-for="doc in docs" :key="doc.value" :value="doc.value">
                        {{ doc.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_com" class="form-control-lg">Solo documentos internos</label>
                  </div>
                  <div class="col-sm-7">
                    <input name="cnt_doc_int" id="cnt_doc_int" class="form-control-lg form-check-input" type="checkbox"
                      v-model="contratoForm.docInternos" value="S">
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <label for="con_plan" class="form-control-lg">Costo</label>
                      <select name="cnt_tip_plan" id="cnt_tip_plan" class="form-select" v-model="contratoForm.plan"
                        v-bind:class="{ 'invalid': errores.plan }">
                        <option value="-1">Seleccione el Plan</option>
                        <option v-for="tipoPlan in tipoPlanes" :key="tipoPlan.value" :value="tipoPlan.value">
                          {{ tipoPlan.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <div class="input-group">
                      <span class="soles input-group-text">S/.</span>
                      <input type="text" class="req inpsol form-control form-control-lg" name="cnt_cos_plan"
                        id="cnt_cos_plan" maxlength="10" v-model="contratoForm.costoPlan"
                        v-bind:class="{ 'invalid': errores.costoPlan }">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_men" class="form-control-lg">Costo mensual</label>
                  </div>
                  <div class="col-sm-7">
                    <div class="input-group">
                      <span class="soles input-group-text">S/.</span>
                      <input type="text" class="req inpsol form-control form-control-lg" name="cnt_cos_men"
                        id="cnt_cos_men" maxlength="10" v-model="contratoForm.costoMensual"
                        v-bind:class="{ 'invalid': errores.costoMensual }">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_anu" class="form-control-lg">Costo de inscripción</label>
                  </div>
                  <div class="col-sm-7">
                    <div class="input-group">
                      <span class="soles input-group-text">S/.</span>
                      <input type="text" class="req inpsol form-control form-control-lg" name="cnt_cos_ins"
                        id="cnt_cos_ins" maxlength="10" v-model="contratoForm.costoInscripcion"
                        v-bind:class="{ 'invalid': errores.costoInscripcion }">
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información adicional</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="con_ini" class="form-control-lg">Inicio promo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="date" class="form-control form-control-lg"
                      v-bind:class="{ 'invalid': errores.inicioPromo }" name="cnt_ini" id="cnt_ini"
                      v-model="contratoForm.inicioPromo" :disabled="disabledDates">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_fin" class="form-control-lg">Fin promo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="date" class="form-control form-control-lg" v-bind:class="{ 'invalid': errores.finPromo }"
                      name="cnt_fin" id="cnt_fin" v-model="contratoForm.finPromo" :disabled="disabledDates">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_pri" class="form-control-lg">Fecha inicio facturación</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="date" class="req form-control form-control-lg" name="cnt_fec" id="cnt_fec"
                      v-model="contratoForm.inicioFacturacion" v-bind:class="{ 'invalid': errores.inicioFacturacion }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="con_com" class="form-control-lg">Sin promoción</label>
                  </div>
                  <div class="col-sm-7 form-check form-switch">
                    <input name="cnt_no_pro" id="cnt_no_pro" class="form-check-input" type="checkbox"
                      @change="ckbPromocion_click" v-model="contratoForm.sinPromocion" value="S">
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row mb-3">
                  <div class="col">
                    <label for="con_obs" class="form-control-lg">Observaciones</label>
                  </div>
                  <div class="col-sm-7">
                    <textarea class="form-control form-control-lg" name="cnt_obs" id="cnt_obs" rows="3"
                      v-model="contratoForm.observaciones" maxlength="255"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cnt_doc_pag" class="form-control-lg" accept="image/*">Subir pago</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="file" class="form-control form-control-lg" id="cnt_doc_pag" name="file"
                      @change="inpFileUpload_handle">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cnt_fec_con" id="cnt_fec_con">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a>
                  </div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click">Guardar</button></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</div></template>
<style>@import 'datatables.net-bs5';</style>